import React from 'react'

import { Answer } from './Answer/Answer'
import style from './AnswersBox.module.css'

import { Task } from 'common/types/entities'

type PropsType = {
  currentTask: Task
  selectedAnswers: string[]
  isAnswered: boolean
  setSelectedAnswers: React.Dispatch<React.SetStateAction<string[]>>
}

export const AnswersBox = ({
  currentTask,
  selectedAnswers,
  isAnswered,
  setSelectedAnswers,
}: PropsType) => {
  return (
    <ul className={style['answers-box']}>
      {currentTask.answers.map((answer, index) => {
        return (
          <Answer
            key={answer.id}
            number={index}
            answer={answer}
            selectedAnswers={selectedAnswers}
            setSelectedAnswers={setSelectedAnswers}
            type={currentTask.type || 'checkbox'}
            isAnswered={isAnswered}
          />
        )
      })}
    </ul>
  )
}
